var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1971_13121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9477 22.9201C43.9477 21.0765 43.7981 19.7311 43.4743 18.3359H22.4219V26.6572H34.7792C34.5301 28.7251 33.1848 31.8394 30.195 33.932L30.1531 34.2106L36.8095 39.3673L37.2707 39.4133C41.506 35.5017 43.9477 29.7465 43.9477 22.9201Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4216 44.8454C28.4757 44.8454 33.5581 42.8522 37.2704 39.4141L30.1948 33.9329C28.3014 35.2534 25.7601 36.1752 22.4216 36.1752C16.4921 36.1752 11.4595 32.2638 9.66551 26.8574L9.40255 26.8798L2.48114 32.2363L2.39062 32.4879C6.07788 39.8126 13.6518 44.8454 22.4216 44.8454Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66658 26.8572C9.19322 25.4621 8.91928 23.9671 8.91928 22.4225C8.91928 20.8777 9.19323 19.383 9.64168 17.9878L9.62914 17.6906L2.62099 12.248L2.3917 12.3571C0.872004 15.3967 0 18.81 0 22.4225C0 26.0351 0.872004 29.4482 2.3917 32.4877L9.66658 26.8572Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4216 8.67006C26.6321 8.67006 29.4722 10.4888 31.0917 12.0086L37.4199 5.82991C33.5334 2.21737 28.4757 0 22.4216 0C13.6518 0 6.07788 5.03261 2.39062 12.3573L9.64061 17.988C11.4595 12.5816 16.4921 8.67006 22.4216 8.67006Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1971_13121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.9695,
    height: 45,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.fc199f65170290bce3becc38da9e318d.svg";
export { ForwardRef as ReactComponent };